export default function getNodes(connection) {
  return connection.edges.map(i => i.node);
}